import app from "lib/app";
import me from "models/me";
import { getStore } from "store";
import { activeBrandSet } from "actions/scope";
import validators from "lib/validators";
import redirectOnLogin from "helpers/redirectOnLogin";
import { parse } from "query-string";
import { fetchSchemas } from "actions/schemas";

export default function (nextState, replace, callback) {
    const brandId = nextState.params.brand || parse(location.search || "").brand;
    if (me.isSignedIn() && (!brandId || !validators.objectId(brandId))) {
        me.unset("last_brand");
        redirectOnLogin({ replace, location: nextState.location });
        callback();
    } else if (me.isSignedIn()) {
        const store = getStore();
        const state = store.getState();
        const { brands = {} } = state.entities || {};
        if (brands[brandId]) {
            // already loaded, just use the cache
            const brandRecord = brands[brandId].toJSON();
            store.dispatch(activeBrandSet(brandRecord));
            store
                .dispatch(fetchSchemas(brandRecord._id))
                .then(() => {
                    me.setActiveBrand(brandRecord);
                    callback();
                })
                .catch(() => {
                    callback();
                });
        } else {
            let brandDeactivated = false;
            let allowGuestBuyer = false;
            app.brands.getOrFetch(
                brandId,
                {
                    handle401: true,
                    error: (_, response) => {
                        if (response.statusCode === 401) {
                            const errorResponse = JSON.parse(response.body);
                            // We need a way to identify that the brand is deactivated and this is the only way now.
                            brandDeactivated = errorResponse.message === "active brand required";
                        } else if (response.statusCode === 403 && me.isBuyer()) {
                            allowGuestBuyer = true;
                        }
                    },
                },
                (err, model) => {
                    if (err) {
                        me.unset("last_brand");
                        !brandDeactivated &&
                            !allowGuestBuyer &&
                            redirectOnLogin({ replace, location: nextState.location });
                        callback();
                    } else {
                        const activeBrand = model.toJSON();
                        store
                            .dispatch(fetchSchemas(activeBrand._id))
                            .then(() => {
                                store.dispatch(activeBrandSet(activeBrand));
                                me.setActiveBrand(activeBrand);
                                callback();
                            })
                            .catch(() => {
                                store.dispatch(activeBrandSet(activeBrand));
                                callback();
                            });
                    }
                }
            );
        }
    } else {
        me.unset("last_brand");
        replace({ pathname: "/login" });
        callback();
    }
}
